module.exports = __webpack_public_path__ + "img/welcome-image.fb9562eb.png";